function getClientId() {
    let gaCookie = document.cookie.match(/_ga=([^;]*)/);

    if (gaCookie) {
        let gaParts = gaCookie[1].split('.');

        if (gaParts.length > 3) {
            return gaParts[2] + '.' + gaParts[3];
        }
    }
    return null;
}

document.addEventListener("DOMContentLoaded", function () {
    let cid = getClientId();

    if (cid) {
        let clientIdFields = document.querySelectorAll('.ga_client_id_js');
        clientIdFields.forEach(function (field) {
            field.value = cid;
        });
    }
});

